var map = {
	"./de.png": 949,
	"./en.png": 950,
	"./es.png": 951,
	"./fr.png": 952,
	"./ja.png": 953,
	"./mk.png": 954,
	"./pt.png": 955,
	"./tr.png": 956,
	"./zh.png": 957
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 948;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 948
// module chunks = 0